import { render, staticRenderFns } from "./create-tpl.vue?vue&type=template&id=672d8ece&"
import script from "./create-tpl.vue?vue&type=script&lang=ts&"
export * from "./create-tpl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports